module.exports = __webpack_public_path__ + "img/t4-gray.522335bd.png";